export type OnboardingState = {
  promo: string,
  aiChatPrompt: string,
};

export const initialOnboardingState: OnboardingState = {
  promo: '',
  aiChatPrompt: '',
};
